export const form = { firstName: '', lastName: '', email: '', phone: '', address: '', message: '' };
export const COMPONENT_NAME = 'enquireModal';
export const TOGGLE_MODAL = 'app/javascript/pro_platform/components/EnquireModal/TOGGLE_MODAL';
export const SET_SUBMITTED = 'app/javascript/pro_platform/components/EnquireModal/SET_SUBMITTED';
export const ENQUIRE = 'app/javascript/pro_platform/components/EnquireModal/ENQUIRE';



// WEBPACK FOOTER //
// ./app/javascript/pro_platform/components/EnquireModal/constants.js